import { useEffect } from 'react';
import { isPricingContextInitialized, initializePricingContext } from './src-utils-pricingContext.js';

const usePricingContextInitialization = (tenant, locale) => {
  useEffect(() => {
    if (!isPricingContextInitialized()) {
      if (locale && tenant) {
        const initializePricingContextAndSetState = async () => {
          const country = locale?.substring(locale.length - 2);
          await initializePricingContext(tenant, country, false);
        };
        initializePricingContextAndSetState();
      }
    }
  }, [tenant, locale]);
};

export { usePricingContextInitialization as default };
//# sourceMappingURL=src-hooks-usePricingContextInitialization.js.map
